import { Component, OnInit, QueryList, ViewChildren, ElementRef, Input, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Subject, Scheduler, ReplaySubject, Subscription } from 'rxjs';
import { RxComponent } from 'app/core/components/common/rx.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { MultiCheckBoxSharedComponent } from '../multi-check-box/multi-check-box.component';
import { RequestService } from 'app/core/services/request.service';
import { Field } from 'app/solar/common/field';
import { UberFilterService } from '../uber-filter/uber-filter.service';
import { UberFilterConfig } from '../uber-filter/uber-filter-config';
import { MultiCheckboxConfig } from '../multi-check-box/multi-checkbox-config';

@Component({
  selector: 'itpx-shared-filter-list',
  templateUrl: './filter-list.component.html',
  styleUrls: ['./filter-list.component.css'],
  animations: [
    trigger('openClose',
      [
        state('collapsed', style({ height: '0px' })),
        state('expanded, void', style({ height: '*' })),
        transition(
          'collapsed <=> expanded', animate('0.4s ease-in-out'))
      ]),
    trigger('rotate',
      [
        state('collapsed', style({ transform: 'rotate(90deg)' })),
        state('expanded, void', style({ transform: 'rotate(0deg)' })),
        transition(
          'collapsed <=> expanded', animate('0.4s ease-in-out'))
      ])]
})
export class FilterListSharedComponent extends RxComponent {

  @Output() private filterChanged = new EventEmitter<any>();

  @Input() private filterFields: Field[];
  @Input() private globalFilter: Observable<string>;
  @Input() private initUrl: string;
  @Input() private listDelegate: (url)=>Observable<any>;
  @Input() refreshFilter: boolean;

  private maxFilterLevel: number;
  private fields: Observable<any[]>;
  private initState = {};
  private in = {}; //input receptor from filter field
  private out = {}; //unicast whether filter field is enabled/ disabled
  private filterUrl = new ReplaySubject<string>();
  private stateExpression: string[];
  private show: boolean[];
  private disabledFilterSubject = new ReplaySubject<any>();
  private disabledFilters: any[];

  constructor(
    private requestService: RequestService,
    private uberFilterService: UberFilterService

  ) {
    super();

  }

  /*
   * TODO: Use caching
   * TODO: Configure filter to enable/disable filter availability dynamically
  */

  ngOnChanges(changes: SimpleChanges) {
    // Should happen when url changes due to external filters or when product changes
    // If product changes, recalc all
    // If global filter applied keep options in each filter
    this.initUrl = this.initUrl.trim();
    this.maxFilterLevel = Math.max.apply(null, this.filterFields.map(it => it.level));
    this.filterFields.filter(it => !it.key).forEach(it => it.key = it.id);
    this.filterFields.forEach(it => {
      this.in[it.key] = new ReplaySubject<any>(1);
      this.out[it.key] = new ReplaySubject<boolean>(1);
    });
    this.stateExpression = Array<string>(this.filterFields.length).fill('expanded');
    this.show = Array<boolean>(this.filterFields.length).fill(true);

    let accumulator = Observable.combineLatest(Object.keys(this.in).map(it => this.in[it])).bindToLifecycle(this);
    // Initialise enabled/ disabled filters
    this.filterUrl.next(this.initUrl);

    // let listObservable = (this.config && this.config.listDelegate) ?
    //   this.delegateList(this.config.listDelegate) :
    //   this.list(this.filterUrl);

    let data = this.filterUrl.switchMap(url => this.listDelegate ?
      this.listDelegate(url) : this.requestService.get(url)).bindToLifecycle(this).subscribe(it => {
        let res = this.uberFilterService.getFilterMappings(it.data,
          [new UberFilterConfig({type: 'checkbox', filterConfig: new MultiCheckboxConfig({ title: 'Delivery Formats',
          id: 'deliveryFormat'}), disableEmitter: null}),
          new UberFilterConfig({type: 'checkbox', affects: [], filterConfig: new MultiCheckboxConfig({  title: 'Certificate Types',
          id: 'certificateType'}), disableEmitter: null}),
          new UberFilterConfig({type: 'checkbox', affects: [], filterConfig: new MultiCheckboxConfig({ title: 'Languages',
          id: 'languageValue'}), disableEmitter: null})]);
        this.disabledFilters = [];
        this.filterFields.forEach((currFilter, index) => {
          // let func = currFilter.updateEditFields; // || this.defaultUpdateEditFields;
          let tmp: Field = { id: currFilter.id, title: currFilter.title, countable: currFilter.countable };
          currFilter.updateEditFields(it.data, tmp);
          if (tmp.options.filter(it => !it.key).length > 0)
            this.disabledFilters.push(currFilter.key);
          this.stateExpression[index] = (tmp.options.filter(it => !it.key).length > 0) ? 'collapsed' : 'expanded';
          this.show[index] = (tmp.options.filter(it => !it.key).length === 0);
        })
        this.filterFields.forEach(it => this.initState[it.key] = true);
        this.disabledFilters.forEach(it => this.initState[it] = false);
        this.disabledFilterSubject.next(this.disabledFilters);
      })

    Observable.zip(accumulator, this.disabledFilterSubject)
      // .skip(1) //Bad idea, the disabled filters are not initialized
      .subscribe(([filterOptions, disabledFilters]) => {
        // update filter availability
        this.filterFields.forEach(it => this.out[it.key].next(disabledFilters.includes(it.key)))
        let url = '';
        let activeFilters = filterOptions.filter(it => !disabledFilters.includes(it.id));
        let idx = activeFilters.findIndex(it => it.id === 'vouchers');
        if (-1 < idx && false === activeFilters[idx].status.noVoucher) {
          url = `${url}&@noVoucher=false`;
        }
        activeFilters
          .filter(exclude => exclude.id !== 'vouchers')
          .forEach(filter => {
            url = `${url}&@${filter.id}=`
            Object.keys(filter.status).forEach(option => {
              if (filter.status[option])
                url = `${url}${option},`
            });
            //guard value in filters. If unique value in filters,
            //the guard will result in returning empty list when filter value gets unselected
            url = `${url}R3S3RV3D`;
          });
        url = url + '&and=1';
        this.filterChanged.next(url);
      });

    this.fields = this.requestService.get(this.initUrl).map(it => {
      this.filterFields.forEach(currFilter => {
        //let func = currFilter.updateEditFields; // || this.defaultUpdateEditFields;
        currFilter.updateEditFields(it.data, currFilter);
        let acc = {};
        currFilter.options.forEach(it => acc[it.key] = it.checked);
        this.in[currFilter.key].next({ id: currFilter.key, status: acc });
        let disableFilter = false;
        if (currFilter.options.filter(it => !it.key).length > 0) {
          disableFilter = true;
          currFilter.options = currFilter.options.filter(it => !!it.key);
        }
        this.initState[currFilter.key] = !disableFilter;
        currFilter.disableEmitter = new ReplaySubject<boolean>(1);
        currFilter.disableEmitter.next(disableFilter);
      });
      return this.filterFields;
    });
  }

  ngOnInit() {
    if (this.globalFilter)
      this.globalFilter
        .switchMap(val => this.requestService.get(`${this.initUrl}${this.initUrl.includes('?') ? '&' : '?&'}filter=${val}`)).map(it => {
          this.filterFields.filter(filt => filt.countable).forEach(currFilter => {
            //let func = currFilter.updateEditFields; // || this.defaultUpdateEditFields;
            let tmp: Field = { id: currFilter.id, title: currFilter.title, countable: currFilter.countable };
            currFilter.updateEditFields(it.data, tmp);
            currFilter.options.forEach(it => {
              let idx = tmp.options.find(itr => itr.key === it.key);
              it.counter = idx ? idx.counter : 0;
            })
          });
        }).subscribe();
  }

  private onTypeSelect(pos: number) {
    this.stateExpression[pos] = this.stateExpression[pos] === 'expanded' ? 'collapsed' : 'expanded';
  }

  private onFormSubmit(value) {
    if (this.filterFields.filter(it => it.key === value.id)[0].level < this.maxFilterLevel) {
      let url = this.initUrl;
      if (value.id === 'vouchers') {
        if (false === value.status.noVoucher) {
          url = `${url}&@noVoucher=false`;
        }
      } else {
        url = `${url}&@${value.id}=`
        Object.keys(value.status).forEach(option => {
          if (value.status[option])
            url = `${url}${option},`
        });
      }
      this.filterUrl.next(url);
    } else {
      this.disabledFilterSubject.next(this.disabledFilters)
    }
    this.in[value.id].next(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/filter-list/filter-list.component.ts